import React from "react"
import PropTypes from "prop-types"

import { searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    OrganizationSearchifyFLV,
    UserFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import { OrganizationSelect, UserSelect } from "app/static/frontend/selects/containers/PieSelect"

export const TeamUserFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={UserFilterableListView} {...props} />
}
TeamUserFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
TeamUserFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "teamUserFilter",
    filterKey: "about_users",
    dataTypeLabel: "Users",
    selectComponent: UserSelect,
}

export const TeamOrganizationFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OrganizationSearchifyFLV} {...props} />
}
TeamOrganizationFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
TeamOrganizationFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "teamOrganizationFilter",
    filterKey: "about_organization",
    dataTypeLabel: "Users",
    selectComponent: OrganizationSelect,
}
